import car from '../car.png'
import '../App.css';
import '../Home/home.css'

function Home() {
  return (
    <div className="App">
      <div class="topnav">
        <a class="active" href="/home">Home</a>
        <a href="/rent">Rent</a>
        <a href="/contact">Contact</a>
        <a href="/about">About</a>
      </div>
      <img src={car} className="App-logo" alt="logo" />        
      <div class="container-fluid text-center">    
        <div class="row content">
          <div class="col-sm-2 sidenav">
          </div>
          <div class="col-sm-8 text-left"> 
            <h1>Welcome</h1>
            <p>We are a small rental agency located in Mountain House, California. We currently have five cars in our fleet, which can be rented through Turo.</p>
            <p>Enhance your vacation with Supersonic Rent-A-Car. Whether you need a car rental for your vacation or business, Supersonic has a wide variety of rental cars available to meet your need.</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
